/**
 * Step node animations
 * Beautiful completion animations for progress nodes
 */

import { STEP_NODE_CONSTANTS } from '../constants';

/**
 * Node completion animation - triggered when progress line reaches the node
 * Creates a beautiful scale-up and scale-down effect
 */
export const nodeCompletionAnimations = {
  '@keyframes nodeCompletionPulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 transparent',
    },
    '50%': {
      transform: `scale(${STEP_NODE_CONSTANTS.COMPLETION_ANIMATION.SCALE_UP})`,
      boxShadow: '0 0 20px 0 rgba(255, 200, 6, 0.3)',
    },
    '100%': {
      transform: `scale(${STEP_NODE_CONSTANTS.COMPLETION_ANIMATION.SCALE_DOWN})`,
      boxShadow: '0 0 0 0 transparent',
    },
  },
};

/**
 * Gets the completion animation CSS for a completed node
 * Calculates delay based on when the progress line actually reaches the node
 */
export const getNodeCompletionAnimation = (
  isCompleted: boolean,
  nodeIndex: number,
  totalNodes: number,
  progressLineDuration = 2.4, // Duration of CompletedProgressLine animation
) => {
  if (!isCompleted) return {};

  // Calculate when the progress line reaches this specific node
  // The progress line takes progressLineDuration to go from first to last node
  // So for nodeIndex out of totalNodes, the timing is proportional
  const progressRatio = totalNodes > 1 ? nodeIndex / (totalNodes - 1) : 0;
  const nodeReachTime = progressRatio * progressLineDuration;

  // Add a small offset so animation starts just as the line reaches the node
  const animationDelay = `${nodeReachTime + 0.1}s`;

  return {
    animation: `nodeCompletionPulse ${STEP_NODE_CONSTANTS.COMPLETION_ANIMATION.DURATION} ${STEP_NODE_CONSTANTS.COMPLETION_ANIMATION.EASING} ${animationDelay} forwards`,
  };
};
